<script>
import appConfig from '@src/app.config.json'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

	page: {
		title: 'Блокировка контакта',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader, Multiselect },

	data() {
        return {
			title: 'Блокировка контакта',
			items: [],
            contact_blacklist_uuid: '',
            trackBy: 'id',
            phone: '',
		}
	},

    watch: {
    
    },

	computed: {
        blacklist_item(){
            let category = this.$store.getters['contactsBlacklist/GET_CONTACTS_BLACKLIST_ITEM'];
            return category;
        },
        contacts_blacklist_list_data(){
            return this.$store.getters['contactsBlacklist/GET_CONTACTS_BLACKLIST_LIST_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            let user = session.user ? session.user : null;
            return user;
        },
	},

	async mounted() {

        this.contact_blacklist_uuid = this.$route.params.contact_blacklist_uuid ? this.$route.params.contact_blacklist_uuid : '';

        await this.$store.dispatch('contactsBlacklist/FETCH_CONTACTS_BLACKLIST_LIST', {'sortBy': 'id', 'sortDesc': 'DESC'});
        this.category_options = this.contacts_blacklist_list_data;

        if(this.contact_blacklist_uuid !== ''){

            this.title = 'Блокировка контакта';
            document.title = appConfig.title + ' - ' + 'Блокировка контакта';

            let data_send = {
                'uuid' : this.contact_blacklist_uuid,
            }

            await this.$store.dispatch('contactsBlacklist/FETCH_CONTACTS_BLACKLIST_ITEM', data_send);

            let blacklist = this.blacklist_item;

            this.phone   = blacklist.phone ? blacklist.phone : null;            
        }
	},

	methods: {

        async saveItem(){

            let data_send = {
                'phone' : this.phone ? this.phone : null,
            };

            let result = '';

            if(this.contact_blacklist_uuid === ''){
                result = await this.$store.dispatch('contactsBlacklist/FETCH_CONTACTS_BLACKLIST_CREATE', data_send);
            } else {
                data_send.uuid = this.contact_blacklist_uuid;
                result = await this.$store.dispatch('contactsBlacklist/FETCH_CONTACTS_BLACKLIST_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Contacts.Blacklist'});
            }
        }
	}
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveItem"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">

                                <b-form-group
                                    label="Номер телефона"
                                    label-for="input-horizontal"
                                >
                                    <b-form-input
                                        id="phone"
                                        v-model="phone"
                                    ></b-form-input>
                                </b-form-group>
                            
                            </div>
                        </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
	</Layout>
</template>
